/* Movatic WMS — Frontend | CesarFilho 932048016 */
import StepWizard from '@/components/StepWizard'
import { useToast } from '@/components/Toast'

export default function Shipping() {
  const { show } = useToast()

  return (
    <StepWizard
      title="Expedição"
      steps={[
        { title: 'Selecionar Ordem/Onda', content: <Step1/> },
        { title: 'Picking', content: <Step2/> },
        { title: 'Packing', content: <Step3/> },
        { title: 'Expedir', content: <Step4/> },
      ]}
      onFinish={() => show({ type: 'success', message: 'Fluxo de Expedição concluído (mock)' })}
    />
  )
}

function Step1() {
  return (
    <div className="grid gap-2">
      <label className="label">Ordem/Onda</label>
      <input className="input" placeholder="Código da ordem/onda" />
    </div>
  )
}
function Step2() {
  return <div className="text-sm">Separação por rota/zona/endereço (mock).</div>
}
function Step3() {
  return <div className="text-sm">Packing com etiquetas de pacote (mock).</div>
}
function Step4() {
  return <div className="text-sm">Despacho com transportadora e tracking (mock).</div>
}
